export class DomainTroubleshoot {
  public ssl: any;
  public pointed: any;
  public server: any;
}
